import script from "./Video.vue?vue&type=script&lang=ts&setup=true"
export * from "./Video.vue?vue&type=script&lang=ts&setup=true"

import "./Video.vue?vue&type=style&index=0&id=5061af7c&lang=less"
import "./Video.vue?vue&type=style&index=1&id=5061af7c&lang=less&scoped=true"

import exportComponent from "/Volumes/未命名/repos/qll-web-work/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5061af7c"]])

export default __exports__